import request from '@/utils/request'

// 獲取
export function docHistoryInfo(query) {
  return request({
    url: '/api/docs_history/docHistoryInfo',
    method: 'get',
    params: query
  })
}

// 新增
export function createDocHistory(data) {
  return request({
    url: '/api/docs_history/docHistoryInfo',
    method: 'post',
    data
  })
}
// 修改
export function updateDocHistory(data) {
  return request({
    url: '/api/docs_history/docHistoryInfo',
    method: 'put',
    data
  })
}

export function deleteDocHistory(id) {
  return request({
    url: '/api/docs_history/docHistoryInfo/' + id,
    method: 'delete'
  })
}

export function countDocHistory(query) {
  return request({
    url: '/api/docs_history/countDocHistory',
    method: 'get',
    params: query
  })
}
